/**
 * Create performance chart data for pigeondoc chart
 * @param {Object} performanceChartData performance analysis chart data
 * @returns performance chart data
 */

const formatPerformanceChartData = (
  performanceChartData,
  threshold,
  sentimentMode,
  performanceMode,
) => {
  // explore handling threshold here instead of in each individual chart, then fix Vertical

  let segmentedData = [];
  let sentimentData = [];
  let formatedData = [];
  let finalData = [];

  // Before continuing, check for segments and reformat the data to include their data
  // TO DO, make question text and title interchangable
  for (let i = 0; i < performanceChartData.length; i++) {
    // First time receiving, if segment exists, reformat
    let found_segments = [];
    let found_sentiments = [];
    let segment_title = '';

    // Original response (from the API) requires [1]
    if (performanceChartData[i][1] && performanceChartData[i][1]['client_question_analysis']) {
      found_segments = deepCloneObj(
        performanceChartData[i][1]['client_question_analysis'].unique_segments_count_dict,
      );
      segment_title = performanceChartData[i][1]['client_question_analysis'].question_title;
    }

    // Modified version of the above using more complex segmentation
    if (performanceChartData[i]['unique_segments_count_dict']) {
      found_segments = deepCloneObj(performanceChartData[i]['unique_segments_count_dict']);
      segment_title = performanceChartData[i]['unique_segments_count_dict'].label;
    }

    // Otherwise it is coming from a saved object
    if (performanceChartData[i] && performanceChartData[i]['client_question_analysis']) {
      found_segments = deepCloneObj(
        performanceChartData[i]['client_question_analysis'].unique_segments_count_dict,
      );
      segment_title = performanceChartData[i]['client_question_analysis'].question_title;
    }

    if (found_segments && found_segments.length) {
      let lastUsedSegment = '';
      for (let x = 0; x < found_segments.length; x++) {
        let newValue;
        if (performanceMode == 'Means/averages' || performanceMode == 'means') {
          if (threshold > -1) {
            newValue = replaceWithThresold(threshold, found_segments[x].Unique_counts_dict);
          } else {
            newValue = found_segments[x].overall_mean;
          }
        } else {
          if (threshold > -1) {
            newValue = replaceWithThresold(threshold, found_segments[x].Unique_counts_dict);
          } else {
            newValue = found_segments[x].valid_data_size;
          }
        }

        let segmentValueAsString = '';
        if (
          typeof found_segments[x].segment_value === 'string' ||
          found_segments[x].segment_value instanceof String
        ) {
          segmentValueAsString = found_segments[x].segment_value;
        } else {
          segmentValueAsString = found_segments[x].segment_value.toString();
        }

        let thisSegment = '';

        if (segment_title) {
          if (lastUsedSegment == '') {
            thisSegment = segment_title;
            lastUsedSegment = thisSegment;
          } else if (lastUsedSegment !== segment_title) {
            thisSegment = segment_title;
          } else if (lastUsedSegment == segment_title) {
            thisSegment = '';
          }
        } else {
          if (lastUsedSegment == '') {
            thisSegment = found_segments[x].client_question_title;
            lastUsedSegment = thisSegment;
          } else if (lastUsedSegment !== found_segments[x].client_question_title) {
            thisSegment = found_segments[x].client_question_title;
          } else if (lastUsedSegment == found_segments[x].client_question_title) {
            thisSegment = '';
          }
        }

        if (
          thisSegment !== '' &&
          found_segments[x].other_segment_value &&
          thisSegment !== found_segments[x].other_segment_value
        ) {
          thisSegment = thisSegment + ' ' + found_segments[x].other_segment_value;
        }

        // let old_label = found_segments[x].client_question_title +
        //     ' - ' +
        //     found_segments[x].question_title +
        //     ' - ' +
        //     segmentValueAsString
        let adjusted_label =
          found_segments[x].client_question_title +
          ' - ' +
          found_segments[x].question_title +
          ' - ' +
          segmentValueAsString;
        if (segment_title) {
          adjusted_label = segment_title + segmentValueAsString;
        }
        if (found_segments[x].other_segment_value) {
          adjusted_label =
            found_segments[x].other_segment_value +
            ' (' +
            found_segments[x].client_question_title +
            ') ' +
            found_segments[x].question_title +
            ' - ' +
            segmentValueAsString;
        }
        let chartObject = {
          value: newValue,
          label: adjusted_label,
          segment_value: segmentValueAsString,
          segment_question: found_segments[x].question_title,
          ques_label_when_segment: thisSegment,
          unique_counts: found_segments[x].Unique_counts_dict,
        };
        if (found_segments[x]['time_series_scores']) {
          chartObject['time_series_scores'] = found_segments[x]['time_series_scores'];
        }
        segmentedData.push(chartObject);
      }
    }

    if (performanceChartData[i] && performanceChartData[i]['unique_sentiments_count']) {
      found_sentiments = deepCloneObj(performanceChartData[i]['unique_sentiments_count']);
    }
    if (
      performanceChartData[i][1] &&
      performanceChartData[i][1]['client_question_analysis']['unique_sentiments_count']
    ) {
      found_sentiments = deepCloneObj(
        performanceChartData[i][1]['client_question_analysis']['unique_sentiments_count'],
      );
    }

    if (found_sentiments && found_sentiments['index'] && found_sentiments['index'].length) {
      for (let x = 0; x < found_sentiments['index'].length; x++) {
        for (let y = 0; y < found_sentiments['data'][x].length; y++) {
          if (y == found_sentiments['data'][x].length - 1) {
            break;
          }

          let newValue = found_sentiments['data'][x][y];

          // let sentimentValueAsString = '';
          // if (
          //   typeof found_sentiments['columns'][x] === 'string' ||
          //   found_sentiments['columns'][x] instanceof String
          // ) {
          //   sentimentValueAsString = found_sentiments['columns'][x];
          // } else {
          //   sentimentValueAsString = found_sentiments['columns'][x].toString();
          // }

          let sentimentValueAsString = found_sentiments['columns'][y];
          let thisSentiment = '';
          // if (lastUsedSentiment == '') {
          //   thisSentiment = found_sentiments[x].client_question_title;
          //   lastUsedSentiment = thisSentiment;
          // } else if (lastUsedSentiment !== found_sentiments[x].client_question_title) {
          //   thisSentiment = found_sentiments[x].client_question_title;
          // } else if (lastUsedSentiment == found_sentiments[x].client_question_title) {
          //   thisSentiment = '';
          // }
          if (sentimentMode == 'Single score') {
            if (sentimentValueAsString == 'Compound score') {
              let chartObject = {
                value: newValue,
                label: found_sentiments['index'][x] + ' - ' + sentimentValueAsString,
                sentiment_value: sentimentValueAsString,
                sentiment_question: found_sentiments['index'][x],
                ques_label_when_sentiment: thisSentiment,
                unique_counts: [],
              };
              if (found_sentiments['data'][x][7] && found_sentiments['data'][x][7].length) {
                chartObject['time_series_scores'] = found_sentiments['data'][x][7];
              }
              sentimentData.push(chartObject);
            }
          } else if (sentimentMode == '5-point scale') {
            if (
              sentimentValueAsString != 'Compound score' &&
              sentimentValueAsString != 'Total count'
            ) {
              let chartObject = {
                value: newValue,
                label: found_sentiments['index'][x] + ' - ' + sentimentValueAsString,
                sentiment_value: sentimentValueAsString,
                sentiment_question: found_sentiments['index'][x],
                ques_label_when_sentiment: thisSentiment,
                unique_counts: [],
              };
              sentimentData.push(chartObject);
            }
          } else {
            // All other cases
            let chartObject = {
              value: newValue,
              label: found_sentiments['index'][x] + ' - ' + sentimentValueAsString,
              sentiment_value: sentimentValueAsString,
              sentiment_question: found_sentiments['index'][x],
              ques_label_when_sentiment: thisSentiment,
              unique_counts: [],
            };
            sentimentData.push(chartObject);
          }
        }
      }
    }
  }
  if (segmentedData.length) {
    formatedData = segmentedData;
  } else {
    formatedData = performanceChartData;
  }

  if (sentimentData.length) {
    formatedData = sentimentData;
  }
  for (let i = 0; i < formatedData.length; i++) {
    // the default format from the backend nestles extra information
    let chartObject = {};
    if (formatedData[i][1]) {
      let unique_counts = deepCloneObj(
        formatedData[i][1]['client_question_analysis'].unique_numbers_count_dict,
      );

      let newValue;
      let preThreshold;
      if (performanceMode == 'Volumes') {
        if (formatedData[i][1]['client_question_analysis'].original_size) {
          preThreshold = formatedData[i][1]['client_question_analysis'].original_size;
        } else if (formatedData[i][1]['client_question_analysis'].valid_size) {
          preThreshold = formatedData[i][1]['client_question_analysis'].valid_size;
        }
      } else {
        if (formatedData[i][1]['client_question_analysis'].overall_mean) {
          preThreshold = formatedData[i][1]['client_question_analysis'].overall_mean;
        } else if (formatedData[i][1]['client_question_analysis'].value) {
          preThreshold = formatedData[i][1]['client_question_analysis'].value;
        }
      }
      if (threshold > -1) {
        newValue = replaceWithThresold(threshold, preThreshold);
      } else {
        newValue = preThreshold;
      }

      chartObject = {
        value: newValue,
        label: formatedData[i][1]['client_question_analysis'].question_title,
        unique_counts: unique_counts,
      };

      if (formatedData[i][1]['client_question_analysis']['time_series_scores']) {
        chartObject['time_series_scores'] =
          formatedData[i][1]['client_question_analysis']['time_series_scores'];
      }

      // If has already been stripped from the backend into useable format
    } else {
      let unique_counts = deepCloneObj(formatedData[i]['unique_numbers_count_dict']);

      chartObject = {
        value: formatedData[i]['value'],
        label: formatedData[i]['label'],
        unique_counts: unique_counts,
      };
      if (formatedData[i]['ques_label_when_segment']) {
        chartObject['ques_label_when_segment'] = formatedData[i]['ques_label_when_segment'];
      }
      if (formatedData[i]['segment_value']) {
        chartObject['segment_value'] = formatedData[i]['segment_value'];
      }
      if (formatedData[i]['segment_question']) {
        chartObject['segment_question'] = formatedData[i]['segment_question'];
      }
      if (formatedData[i]['theme_color']) {
        chartObject['theme_color'] = formatedData[i]['theme_color'];
      }
      if (formatedData[i]['time_series_scores']) {
        chartObject['time_series_scores'] = formatedData[i]['time_series_scores'];
      }
    }
    if (chartObject) {
      finalData.push(chartObject);
    }
  }

  return finalData;
};

function roundToTwo(num) {
  return +(Math.round(num + 'e+2') + 'e-2');
}

function deepCloneObj(obj) {
  // deep clones an object using JSON stringify (data loss might occur)
  if (Array.isArray(obj)) {
    return obj.map((item) => JSON.parse(JSON.stringify(item)));
  } else if (typeof obj == 'object') {
    return JSON.parse(JSON.stringify(obj));
  }
}

function replaceWithThresold(threshold, unique_counts) {
  let keys = Object.keys(unique_counts);
  if (threshold > -1 && keys.length) {
    let countPositive = 0;
    let countNegative = 0;
    for (let x = 0; x < keys.length; x++) {
      let keyName = keys[x];
      if (parseFloat(keyName) > threshold) {
        countPositive = countPositive + parseFloat(unique_counts[keyName]);
      } else {
        countNegative = countNegative + parseFloat(unique_counts[keyName]);
      }
    }
    let newValue = (countPositive / (countPositive + countNegative)) * 100;
    return roundToTwo(newValue);
    // suffix = "%"
  } else {
    return '';
  }
}

export { formatPerformanceChartData };
